import { FC } from 'react';
import { faClouds, faDownload, faServer, faWindow } from '@fortawesome/pro-regular-svg-icons';
import { Tooltip } from '@tryhackme/thm-ui-components';
import { TaskType } from 'src/common/enums/task';
import { useAppSelector } from 'src/app/hooks';
import { CLOUD_DETAILS_ICON_TOOLTIP_MESSAGE, DEPLOYABLE_MACHINE_ICON_TOOLTIP_MESSAGE, DOWNLOADABLE_ICON_TOOLTIP_MESSAGE, STATIC_WEBSITE_ICON_TOOLTIP_MESSAGE } from './accordion.constants';
import { StyledCloudDetailsIcon, StyledDownloadableIcon, StyledIconWrapper, StyledServerWindowIcon, StyledTooltip } from './accordion.styles';
import { AccordionProps, IconWrapperProps } from './accordion.types';
const DownloadableIcon = <StyledDownloadableIcon data-testid={TaskType.DOWNLOADABLE} icon={faDownload} />;
const StaticWebsiteIcon = <StyledServerWindowIcon data-testid={TaskType.STATIC_SITE} icon={faWindow} />;
const DeployableMachine = <StyledServerWindowIcon data-testid={TaskType.VM} icon={faServer} />;
const CloudDetailsIcon = <StyledCloudDetailsIcon data-testid={TaskType.AZURE} icon={faClouds} />;
const IconWrapper: FC<IconWrapperProps> = ({
  title,
  children,
  width
}) => {
  const {
    tutorPanelOpen,
    vmPanelOpen
  } = useAppSelector(state => state.splitScreen);
  const splitScreenOpen = tutorPanelOpen || vmPanelOpen;
  return <StyledIconWrapper $splitScreenOpen={splitScreenOpen} data-sentry-element="StyledIconWrapper" data-sentry-component="IconWrapper" data-sentry-source-file="header-icon.tsx">
      <StyledTooltip $width={width} data-sentry-element="StyledTooltip" data-sentry-source-file="header-icon.tsx">
        <Tooltip data-testid="tooltip-title" arrowPosition="right" data-sentry-element="Tooltip" data-sentry-source-file="header-icon.tsx">
          {title}
        </Tooltip>
      </StyledTooltip>
      {children}
    </StyledIconWrapper>;
};
export const Icon: FC<Pick<AccordionProps, 'type'>> = ({
  type
}) => {
  if (type === TaskType.DOWNLOADABLE) return <IconWrapper title={DOWNLOADABLE_ICON_TOOLTIP_MESSAGE}>{DownloadableIcon}</IconWrapper>;
  if (type === TaskType.VM || type === TaskType.THM) return <IconWrapper title={DEPLOYABLE_MACHINE_ICON_TOOLTIP_MESSAGE}>{DeployableMachine}</IconWrapper>;
  if (type === TaskType.STATIC_SITE) return <IconWrapper width={14} title={STATIC_WEBSITE_ICON_TOOLTIP_MESSAGE}>
        {StaticWebsiteIcon}
      </IconWrapper>;
  if (type === TaskType.AZURE) {
    return <IconWrapper title={CLOUD_DETAILS_ICON_TOOLTIP_MESSAGE}>{CloudDetailsIcon}</IconWrapper>;
  }
  return null;
};